const confimeaDictEN = {
  headerPartnership: "Partnership",
  headerHelp: "Help",
  headerBackToConfimea: "Back to Confimea website",
  heroBadge: "Welcome to the Business Square of Confimea Imprese",
  heroTitle: "Activate your digital access",
  heroTitleSpan: "on Business Square",
  heroText: "If your company is associated with Confimea Imprese, request Manager access and start immediately leveraging Business Square's digital processes.",
  heroButton: "REQUEST MANAGER ACTIVATION",
  heroStat1Value: "500+",
  heroStat1Label: "Active companies",
  heroStat2Value: "24h",
  heroStat2Label: "Fast activation",
  heroStat3Value: "98%",
  heroStat3Label: "Customer satisfaction",
  benefitsBadge: "EXCLUSIVE BENEFITS",
  benefitsTitle: "Why activate the Manager profile on the Business Square platform?",
  benefitsSubtitle: "Tools designed to digitize and grow your associated company in the digital network.",
  benefit1Title: "Structured digital presence",
  benefit1Text: "Create your company profile and manage online visibility with simple and dedicated tools.",
  benefit2Title: "CashBack and loyalty",
  benefit2Text: "Integrate loyalty programs to encourage customers to return and increase sales.",
  benefit3Title: "Dedicated Confimea support",
  benefit3Text: "Access priority support dedicated to Confimea Imprese members for every need.",
  benefit4Title: "Analytics and reporting",
  benefit4Text: "Monitor your business performance with intuitive dashboards and detailed reports.",
  benefit5Title: "Business Square Network",
  benefit5Text: "Join a network of companies and access business opportunities and networking.",
  benefit6Title: "Digital certification",
  benefit6Text: "Get badges and certifications that attest to your membership in the Confimea network.",
  benefitLink: "Learn more",
  benefitsInfoBannerText: "Need more information?",
  benefitsInfoBannerText2: "Contact our team and we will help you get started.",
  benefitsInfoBannerButton: "Contact support",
  howItWorksBadge: "SIMPLE PROCESS",
  howItWorksTitle: "How does Manager profile activation work?",
  howItWorksSubtitle: "Three simple steps to activate the digitization of your associated company.",
  step1Title: "Fill out the form",
  step1Text: "Enter your company data and the information required for verification.",
  step1Link: "2 minutes",
  step2Title: "Verification and approval",
  step2Text: "Your profile will be verified by the team to confirm your membership.",
  step2Link: "24-48 hours",
  step3Title: "Immediate activation",
  step3Text: "Receive platform access and start managing your business immediately.",
  step3Link: "Immediate",
  ctaBadge: "Start today",
  ctaTitle: "Ready to start?",
  ctaText: "With a few simple steps you can activate access to the Business Square platform and start managing your business digitally and professionally.",
  ctaButton: "Fill out the form",
  formBadge: "Quick registration",
  formTitle: "Request Manager access",
  formSubtitle: "Fill out the form and within 24 hours you will receive activation of your account as Manager on the platform.",
  formCompanyLabel: "Company/Entity Name",
  formCompanyPlaceholder: "E.g. Rossi Medical Practice",
  formNameLabel: "First and Last Name",
  formNamePlaceholder: "Mario Rossi",
  formEmailLabel: "Business email",
  formEmailPlaceholder: "name@company.com",
  formPasswordLabel: "Password",
  formPasswordPlaceholder: "Create a secure password",
  formPartnerCodeLabel: "Partner Code",
  formPartnerCodeOptional: "(optional)",
  formPartnerCodePlaceholder: "If you have a partner code, enter it here",
  formAcceptTerms: "I accept the",
  formTermsLink: "Terms and Conditions",
  formAnd: "and the",
  formPrivacyLink: "Privacy Policy",
  formTermsSuffix: "of Extraconomy and Confimea Imprese.",
  formAcceptMarketing: "I consent to receive commercial communications and service updates.",
  formSubmit: "Send activation request",
  formCaptcha: "Protected by reCAPTCHA - Google Privacy and Terms",
  partnershipBadge: "Official partnership",
  partnershipTitle: "Official partnership",
  partnershipSubtitle: "A channel dedicated exclusively to companies associated with Confimea Imprese to access digitization and active features.",
  partnershipLink1: "See all benefits",
  partnershipLink2: "Register now",
  faqBadge: "FAQ",
  faqTitle: "Frequently asked questions",
  faqSubtitle: "Find answers to the most common questions about the partnership and activation.",
  faq1Question: "Who can access when activating an activation?",
  faq1Answer:
    "Only companies officially associated with Confimea Imprese can fill out this form. During the verification process, we will carefully check the associated code provided to confirm membership in the network and ensure access to the exclusive benefits of the partnership.",
  faq2Question: "Is active service/assistance included in the Manager plan?",
  faq2Answer:
    "No. After submitting the form, our team carefully verifies the data and association with Confimea Imprese. Subsequently, we will contact you to complete the activation and provide you with access credentials. The verification process typically takes 24-48 working hours, but we work to be as fast as possible.",
  faq3Question: "Is technical staff required to use the platform?",
  faq3Answer:
    "Absolutely not. Business Square has been specifically designed for business managers, with an intuitive and easy-to-use interface. No particular technical experience is required. In addition, we offer complete initial training and dedicated support for all new Managers, ensuring a smooth and productive onboarding.",
  faq4Question: "What are the costs associated with the Manager plan?",
  faq4Answer:
    "For companies associated with Confimea Imprese, the Manager plan includes special conditions agreed upon in the partnership. Our team will provide all details on costs and conditions during the activation process, along with a complete presentation of available features.",
  faq5Question: "Can I cancel Manager access at any time?",
  faq5Answer:
    "Yes, you have full freedom to manage your access. You can request suspension or cancellation at any time by contacting dedicated support. There are no rigid contractual constraints, and our goal is always to ensure maximum satisfaction and flexibility for partners.",
  contactTitle: "Have other questions?",
  contactText: "Our team is ready to help you and answer all your questions in real time.",
  contactButton1: "Contact us now",
  contactButton2: "Go to FAQ",
  footerPartnership: "Partnership",
  footerLink1: "For Associated Companies",
  footerLink2: "How it works",
  footerLink3: "FAQ",
  footerQuickLinks: "Quick links",
  footerLink4: "Extraconomy website",
  footerLink5: "Request access",
  footerLink6: "Support",
  footerContacts: "Contacts",
  footerCopyright: "Extraconomy Global srl - P.IVA 16948681008 - All rights reserved",
  email: "Email",
  fullName: "Full name",
  formSuccessBadge: "Registration completed",
  formSuccessTitle: "Verify your email",
  formSuccessSubtitle: "We sent a confirmation link to your email. Click on the link to activate your Manager account and start using the Business Square platform.",
  formSuccessMessage: "We sent a confirmation email to:",
  formSuccessNote: "Please check your inbox and activate your account through the link sent in the email.",
  formSuccessStep1: "Open the email we sent you",
  formSuccessStep2: "Click on the confirmation button",
  formSuccessStep3: "You will be redirected to the platform login",
  formSuccessEmailNotReceived:
    "Didn't receive the email? Check your spam folder.",
  emailVerified: "Email Verified!",
  completeActivationSubtitle: "Complete activation by sending the requested documentation",
  requiredDocuments: "Required Documents for complete activation",
  document1: "To complete the validation of your registration in Confimea Imprese on Business Square, we will request these documents.",
  document2: "You can prepare them and send them with care: it is not necessary to do it immediately.",
  document3: "Download the form, complete it and sign it. You can upload the form and the other documents in your personal area when it is most convenient for you.",
  downloadTemplateDocument: "DOWNLOAD TEMPLATE DOCUMENT",
  uploadYourDocuments: "Upload your documents",
  uploadedFiles: "Uploaded files",
  ready: "Ready",
  chooseFile: "Choose file",
  dragFilesHereOrClick: "Drag files here or click to select",
  fileFormatsHint: "PDF, JPG, PNG (Max 10MB per file)",
  documentsVerificationInfo: "Documents will be verified within 24 working hours. You will receive an email confirmation.",
  skipAndGoToLogin: "SKIP AND GO TO LOGIN",
  sendDocumentation: "SEND DOCUMENTATION",
  privacyNote: "Your documents will be treated confidentially according to GDPR regulations.",
  confirmingEmail: "Confirming email...",
  confirmationMissingParams: "Missing confirmation parameters",
  confirmationError: "Error confirming email",
  fileUploadedSuccessfully: "File uploaded successfully",
  pleaseUploadDocument: "Please upload a document",
  documentSentSuccessfully: "Documentation sent successfully",
  confirmationDocumentDescription: "Confimea Imprese activation documentation",
  goToLogin: "Go to Login",
  removeFile: "Remove",
  documentsReceived: "DOCUMENTS RECEIVED",
  documentationSentSuccessfully: "Documentation sent successfully!",
  documentationSentSuccessfullySubtitle: "Thank you for submitting your documents. Our verification team will start the validation process.",
  emailConfirmation: "Email confirmation",
  emailConfirmationDescription: "You will receive a confirmation email at the provided address.",
  verificationTime: "Verification time",
  verificationTimeDescription: "The verification process usually takes 24-48 working hours.",
  activationNotification: "Activation notification",
  activationNotificationDescription: "Once approved, you will receive access credentials via email.",
  whatHappensNow: "What happens now?",
  whatHappensNow1: "The Confimea Imprese team will verify the submitted documents",
  whatHappensNow2: "If necessary, we may contact you for further clarification",
  whatHappensNow3: "You will receive access credentials to the Manager platform",
  whatHappensNow4: "You can start managing your clients and their documents",
  goToLoginPage: "GO TO LOGIN PAGE",
  associationDocumentUnavailable:
    "Unable to load the association document. Please try again later.",
  paymentSummary: "Operation summary:",
  preferPayPal: "If you prefer, pay with PayPal",
};

export default confimeaDictEN;

